export default __webpack_public_path__ + "static/media/enghien14.79df1ab7.jpg";